import validateSpanishId from './rules/validateSpanishId';
import validateIBAN from './rules/validateIBAN';
import validateClientAge from './rules/validateDates';

const regexPhone = /^([9,7,6]{1})+([0-9]{8})$/;
const regexZipCode = /0[1-9][0-9]{3}|[1-4][0-9]{4}|5[0-2][0-9]{3}/;
const rangeDate = /^\d{2}[./-]\d{2}[./-]\d{4}\s[-]\s\d{2}[./-]\d{2}[./-]\d{4}$/;
const registrationPlateVehicle = /^[0-9]{4}[BCDFGHJKLMNPRSTVWXYZ]{3}$/;

const formatStringDate = stringDate => {
  if (typeof stringDate !== 'string') return stringDate;
  const [day, month, year] = stringDate.split('/');
  return `${year}-${month}-${day}`;
};

const getRangeDate = rangeDates => {
  const [start, end] = rangeDates.split(' - ');
  const startDate = new Date(formatStringDate(start)).getTime();
  const endDate = new Date(formatStringDate(end)).getTime();
  return [startDate, endDate];
};

const checkValidRangeMin = (rangeDates, [from] = []) => {
  const [startDate] = getRangeDate(rangeDates);
  const fromDate = from && new Date(formatStringDate(from)).getTime();
  return startDate > fromDate;
};

const checkValidRangeMax = (rangeDates, [to] = []) => {
  const [, endDate] = getRangeDate(rangeDates);
  const toDate = to && new Date(formatStringDate(to)).getTime();
  return endDate < toDate;
};

const validators = Validator => {
  // Two consecutive Dates
  Validator.extend('range_date', value => rangeDate.test(value));

  Validator.extend('range_min', checkValidRangeMin, ['from']);

  Validator.extend('range_max', checkValidRangeMax, ['to']);
  // Phone
  Validator.extend('phone', value => regexPhone.test(value) && value.length === 9);

  // Zip code
  Validator.extend('zip_code', value => regexZipCode.test(value) && value.length === 5);

  // DNI
  Validator.extend('dni', value => {
    const { type, valid } = validateSpanishId(value.toUpperCase());
    return type === 'dni' && valid;
  });

  // NIE
  Validator.extend('nie', value => {
    const { type, valid } = validateSpanishId(value.toUpperCase());
    return type === 'nie' && valid;
  });

  // CIF
  Validator.extend('cif', value => {
    const { type, valid } = validateSpanishId(value.toUpperCase());
    return type === 'cif' && valid;
  });

  // Document Number (DNI or NIE)
  Validator.extend('document_number', value => {
    const { type, valid } = validateSpanishId(value.toUpperCase());
    return (type === 'dni' || type === 'nie') && valid;
  });

  // IBAN
  Validator.extend('iban', value => validateIBAN(value));

  // Registration plate vehicles
  Validator.extend('registration_plate', value =>
    registrationPlateVehicle.test(value.toUpperCase())
  );

  // Client older than or equal to 25 years
  Validator.extend('client_age_ge', (value, ageThreshold) =>
    validateClientAge('ge', value, ageThreshold)
  );

  // Client older less or equal to 70 years
  Validator.extend('client_age_le', (value, ageThreshold) =>
    validateClientAge('le', value, ageThreshold)
  );

  // Client older between 22 - 75 years.
  Validator.extend('client_age_between', (value, ageMinMax) =>
    validateClientAge('between', value, ageMinMax)
  );
};

export { validators as default };
